export default "__VITE_ASSET__BM_ju3kR__"